export default __webpack_public_path__ + "static/media/ic-analytics-inactive.33add7ea.svg";